import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "mt-4"
};
const _hoisted_2 = {
  class: "pl-4 pr-4 pt-3 pb-3 border-radius-20 dashboard-card"
};
const _hoisted_3 = {
  class: "d-flex flex-row mb-3 mt-1"
};
const _hoisted_4 = {
  class: "fw-extra-bold fsi-20"
};
const _hoisted_5 = {
  key: 0,
  class: "fsi-14"
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chart_block = _resolveComponent("chart-block");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(_ctx.$t('stake.SupplyAPY')), 1), _ctx.$i18n.locale === 'zh' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('stake.APY')), 1)) : _createCommentVNode("", true)]), _hoisted_6]), _createVNode(_component_chart_block, {
    ref: "liquidityRate",
    height: "350px",
    option: $data.optionLiquidityRate,
    onChartSelect: $options.chartLquidityRateSelect
  }, null, 8, ["option", "onChartSelect"])])]);
}